// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TermsGate from './TermsGate';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const kycStatus = userData?.user?.kyc_status;
  const isKycPage = location.pathname === '/kyc-verification';

  if (kycStatus !== 'approved' && !isKycPage) {
    return <Navigate to="/kyc-verification" replace />;
  }

  if (kycStatus === 'approved' && isKycPage) {
    return <Navigate to="/dashboard" replace />;
  }

  // Terms come after verification: no point asking someone to accept them
  // while they still cannot transact.
  return <TermsGate>{children}</TermsGate>;
};

export default ProtectedRoute;
